<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fModalidad"
        name="nomModalidadesAutorizaciones">
    <div class="grid ">
      <div class="col-12 md:col-6 lg:col-4">
        <div class="div-form">
          <label>* {{ 'MODALIDADES.LBL_REINCIDENCIA' | translate }}</label>
          <input type="text" pInputText id="reincidencia"
                 name="nomReincidencia"
                 autocomplete="off"
                 formControlName="reincidencia"
                 numero-entero-reactive
                 [maxlength]="5"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.reincidencia.invalid">
            {{ 'MODALIDADES.LBL_REINCIDENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-4">
        <div class="div-form">
          <label>* {{ 'MODALIDADES.LBL_DIASMORA' | translate }}</label>
          <input type="text" pInputText id="diasMora"
                 name="nomDiasMora"
                 autocomplete="off"
                 formControlName="diasMora"
                 numero-entero-reactive
                 [maxlength]="5"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diasMora.invalid">
            {{ 'MODALIDADES.LBL_DIASMORA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-4 pt-4">
        <div class="div-form">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{ (modalidad.reincidencia && modalidad.diaMora ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR' ) | translate }}"
                    type="submit"
                    pButton></button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <br>

  <div *ngIf="modalidad.reincidencia && modalidad.diaMora">
    <form [formGroup]="formularioCalificacion" (ngSubmit)="onSubmitModalidadCalificacion()" novalidate id="fModalidadesTasas"
          name="nomModalidadesAutorizaciones">
      <div class="grid ">
        <div  *ngIf="!modalidadCalificacion" class="col-12 md:col-6 lg:col-3">
          <div class="div-form">
            <label>* {{ 'MODALIDADES.LBL_CATEGORIA' | translate }}</label>
            <p-dropdown disableTab  id="categoria" name="nomAutorizacion" [options]="lisCategorias"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        filter="filter"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         formControlName="idCategoriaModalidadCalificacion"
                        optionValue="value"
                        optionLabel="label"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedCalificacion && fCalificacion.idCategoriaModalidadCalificacion.invalid" >
              {{ 'MODALIDADES.LBL_CATEGORIA' | translate}}
            </div>
          </div>
        </div>
        <div *ngIf="modalidadCalificacion" class="col-12 md:col-6 lg:col-3">
          <div class="div-form">
            <label>* {{ 'MODALIDADES.LBL_CATEGORIA' | translate }}</label>
            <label  class="falso-combo-texto">{{modalidadCalificacion.nombreCategoria}}</label>
          </div>
        </div>


        <div class="col-12 md:col-6 lg:col-3">
          <div class="div-form">
            <label>* {{ 'MODALIDADES.LBL_DIAMINMORA' | translate }}</label>
            <input type="text" pInputText id="diaMinimoMora"
                   name="nomdiaMinimoMora"
                   autocomplete="off"
                   formControlName="diaMinimoMora"
                   numero-entero-reactive
                   [maxlength]="5"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedCalificacion && fCalificacion.diaMinimoMora.invalid">
              {{ 'MODALIDADES.LBL_DIAMINMORA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <div class="div-form">
            <label>* {{ 'MODALIDADES.LBL_DIAMAXMORA' | translate }}</label>
            <input type="text" pInputText id="diaMaximoMora"
                   name="nomdiaMaximoMora"
                   autocomplete="off"
                   formControlName="diaMaximoMora"
                   numero-entero-reactive
                   [maxlength]="5"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submittedCalificacion && fCalificacion.diaMaximoMora.invalid">
              {{ 'MODALIDADES.LBL_DIAMAXMORA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <div class="div-form">
            <div *ngIf="!guardandoCalificacion">
              <button icon="fa fa-plus" label="{{ (modalidadCalificacion ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR' ) | translate }}"
                      type="submit"
                      pButton></button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas"
                 [value]="lisModalidadesCalificaciones" selectionMode="single" dataKey="idAutorizacion"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.codigoCategoria}}</td>
              <td>{{row.diaMinimoMora}}</td>
              <td>{{row.diaMaximoMora}}</td>

              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_ELIMINAR' | translate}}" *ngIf="menu.editar"
                          pButton (click)="eliminarModalidadCalificacion(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                          (click)="editarModalidadCalificacion(row)"></button>
                </div>
              </td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </div>

</div>

<p-confirmDialog #cd key="productos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
